import { createApi } from "@reduxjs/toolkit/query/react";

import { createCustomFetchBaseQuery } from "../baseQuery";

export const contractorDashboardApi = createApi({
    reducerPath: "contractorDashboard",
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        getDashboardData: builder.query({
            query: () => ({
                url: `/contractor/home`,
                method: "GET",
            }),
        }),
        getDashboardDetails: builder.query({
            query: () => ({
                url: `/contractor/home/details`,
                method: "GET",
            }),
        }),
        getDashboardRecentActivities: builder.query({
            query: ({ pageno ,limit }) => ({
                url: `/contractor/home/recent-activities?pageno=${pageno}&limit=${limit}`,
                method: "GET",
            }),
        }),
    }),
})

export const {
    useGetDashboardDataQuery,
    useGetDashboardDetailsQuery,
    useGetDashboardRecentActivitiesQuery
} = contractorDashboardApi;